import { render, staticRenderFns } from "./shop-item.vue?vue&type=template&id=e9e0a062&scoped=true"
import script from "./shop-item.vue?vue&type=script&lang=js"
export * from "./shop-item.vue?vue&type=script&lang=js"
import style0 from "./shop-item.vue?vue&type=style&index=0&id=e9e0a062&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e0a062",
  null
  
)

export default component.exports